import { FC, PropsWithChildren, ReactNode } from 'react'
import cn from 'classnames'
import styles from './styles.module.scss'

type CardLayoutProps = {
  title?: ReactNode
  padded?: boolean
  dimmed?: boolean
}

export const CardLayout: FC<PropsWithChildren<CardLayoutProps>> = ({ title, padded, dimmed, children }) => {
  return (
    <div className={cn(styles.card, { [styles.cardDimmed]: dimmed })}>
      {title && <div className={styles.cardHeader}>{title}</div>}
      <div className={cn({ [styles.cardContentPadded]: padded })}>{children}</div>
    </div>
  )
}
